import React from 'react';
import classnames from 'classnames';

const MaxWidthContainer = (props) => {
  const { noPending = false, className, children, ...restProps } = props;

  return (
    <div
      className={classnames(
        'mx-auto w-full max-w-screen-2xl',
        { 'lg:px-8 2xl:px-20': !noPending },
        className
      )}
      {...restProps}
    >
      {children}
    </div>
  );
};

export default MaxWidthContainer;
